import React from "react";
import ZImage from "@atoms/ZImage";
import ZTooltip from "@atoms/ZTooltip";
import ZIcon, { Icons } from "@atoms/ZIcon";
import { IItemImagesProps } from "./interface";
import { EProductDrawerState } from "@/V2Components/pages/Drawers/Products/Product/interface";
import { fallbackImageURL } from "@/Contracts";
import { getProductImageUrl } from "@/Utils/common";

const ZItemImages: React.FC<IItemImagesProps> = ({
	productImageList,
	deleteProductImage,
	showPreviewProductImageModal,
	showProductImageUploadModal,
	drawerState
}) => {
	return (
		<div className="flex items-center flex-wrap">
			{productImageList?.map((productImage, index) => {
				return (
					<div
						key={index}
						className="border relative border-solid border-gray-5 rounded mr-2"
					>
						<ZImage
							src={getProductImageUrl(productImage)}
							alt="Product"
							height={91}
							width={89}
							preview={false}
							className="object-contain"
							fallback={fallbackImageURL}
						/>
						<div
							className="absolute top-0.5 opacity-0 hover:opacity-100 hover:bg-gray-10 hover:bg-opacity-50"
							style={{ height: 95, width: 89 }}
						>
							<ZTooltip title="Preview" placement="bottom">
								<ZIcon
									name={Icons.EYE}
									onClick={() => {
										showPreviewProductImageModal(
											productImage
										);
									}}
									className={`${
										drawerState !==
										EProductDrawerState.BUNDLECHILDEDIT
											? "ml-3 mr-4"
											: "ml-8"
									} mt-8 cursor-pointer`}
									colorVariant={1}
								/>
							</ZTooltip>
							{drawerState !==
								EProductDrawerState.BUNDLECHILDEDIT && (
								<ZTooltip title="Delete" placement="bottom">
									<ZIcon
										name={Icons.TRASH}
										onClick={() => {
											deleteProductImage(productImage);
										}}
										className="mt-8 cursor-pointer"
										colorVariant={1}
									/>
								</ZTooltip>
							)}
						</div>
					</div>
				);
			})}
			{drawerState !== EProductDrawerState.BUNDLECHILDEDIT && (
				<div
					className="flex flex-col items-center justify-center border border-solid border-gray-5 rounded py-5 px-6 hover:bg-gray-3 cursor-pointer"
					onClick={showProductImageUploadModal}
				>
					<div className="mb-2">
						<ZIcon name={Icons.UPLOAD} />
					</div>
					<div>Upload</div>
				</div>
			)}
			{drawerState === EProductDrawerState.BUNDLECHILDEDIT &&
				(!productImageList || productImageList.length === 0) && (
					<div className="my-3">No product images to display</div>
				)}
		</div>
	);
};

export default ZItemImages;
